import { QUERY_KEYS } from '@forwardflow/helpers/utils/constants'
import CampaignService from '@forwardflow/services/CampaignService'
import useSWR from 'swr'

export const useGetCampaignsOverview = (
   type: string,
   time_frame: string,
   time_frame_unit: string
) => {
   const response = useSWR(
      [QUERY_KEYS.CAMPAIGNS_OVERVIEW, type, time_frame, time_frame_unit],
      () =>
         CampaignService.getCampaignsOverview({
            type,
            time_frame,
            time_frame_unit,
         })
   )
   return {
      ...response,
   }
}
